import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getSpaceState, setSpaceStateToStore } from '../slices/spaceSlice'
import liveInstance from "../liveController/createLiveInstance";

const { useKeyframe, useSelfInfo } = liveInstance
// const { useKeyframe } = liveInstance

function useSpaceState () {
	const spaceState = useSelector(getSpaceState)
	const dispatch = useDispatch()
	const [state, updateState] = React.useState(spaceState)
	// const [spaceStateKeyframe, setSpaceStateKeyframe] = useKeyframe('SpaceState')
	const [, setSpaceStateKeyframe] = useKeyframe('SpaceState')
	const [selfInfo] = useSelfInfo()
	
	const setState = React.useCallback((
		state,
		userAction = true
	) => {
		const nextState = typeof state === 'function' ? state() : state
		// 在此处理live发送逻辑
		if (userAction && spaceState.mode === 'live' && selfInfo?.permission?.sync_frame) { // TODO：在此拿 userInfo 做权限相关校验，会导致update逻辑阻塞 bug
			setSpaceStateKeyframe(nextState)
		}
		
		dispatch(setSpaceStateToStore(nextState))
		
	}, [dispatch, setSpaceStateKeyframe, spaceState.mode, selfInfo])
	
	React.useEffect(() => {
		return updateState(spaceState)
	}, [spaceState])

	return [state, setState]
}

export { useSpaceState } ;
